/**
 * Hidden lead fields for the quiz book CTA (CommonJS: Node tests + Mix).
 */

function quizDomain(opts) {
  opts = opts || {};
  var raw = opts.domain != null ? String(opts.domain).trim() : "";
  if (
    !raw &&
    typeof window !== "undefined" &&
    window.location &&
    window.location.hostname
  ) {
    raw = String(window.location.hostname);
  }
  raw = String(raw)
    .trim()
    .toLowerCase()
    .replace(/^https?:\/\//, "")
    .replace(/:\d+$/, "")
    .split("/")[0];
  return raw;
}

function quizBookAnswers(opts) {
  opts = opts || {};
  const out = {};
  const url = opts.bookUrl != null ? String(opts.bookUrl).trim() : "";
  if (url && url !== "#") out.book_url = url;
  const hash = opts.ticketHash != null ? String(opts.ticketHash).trim() : "";
  if (hash) out.ticket_hash = hash;
  const domain = quizDomain(opts);
  if (domain) out.domain = domain;
  return out;
}

module.exports = { quizBookAnswers, quizDomain };
